// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  partyId: __t.u64().name("party_id"),
  state: __t.u8(),
  pulseIndex: __t.u32().name("pulse_index"),
  snapshot: __t.byteArray(),
  snapshotHash: __t.byteArray().name("snapshot_hash"),
  declaration: __t.byteArray(),
  inputsHash: __t.byteArray().name("inputs_hash"),
  outcome: __t.option(__t.u8()),
  openedAt: __t.timestamp().name("opened_at"),
  endedAt: __t.option(__t.timestamp()).name("ended_at"),
  fleeCalled: __t.bool().name("flee_called"),
  name: __t.string(),
  pendingSurrender: __t.bool().name("pending_surrender"),
  boardW: __t.u8().name("board_w"),
  boardH: __t.u8().name("board_h"),
  instanceId: __t.option(__t.u64()).name("instance_id"),
  difficultyBp: __t.u16().name("difficulty_bp"),
  leaderNpc: __t.option(__t.u64()).name("leader_npc"),
  regardStrip: __t.array(__t.string()).name("regard_strip"),
});
